import { ApolloQueryResult } from '@apollo/client';
import { SummarySectionV2 } from '@css-xp/base';
import { EntitlementDetails } from '@css-xp/graphtypes/src/generated-types-new';
import React, { Fragment } from 'react';
import { EntitlementsCommonColumns } from '../entitlment-summary-utils';
import { PromotionsSummary } from '../promotions-summary';
import { NextPriceEstimateSection, UUIDSection, PageUrlSection, StatusSection } from './sections';
import Button from '@atlaskit/button/standard-button';
import { useHistory } from 'react-router';
import { isAppEntitlement } from '../../../entitlement-page';
import { OfferingType } from '@atlassian/cssxp-ccp-types';

export const StatuspageTemplate = ({
  entitlement,
  refetch,
}: {
  entitlement: EntitlementDetails;
  refetch: () => Promise<ApolloQueryResult<unknown>>;
}) => {
  const { addOns } = entitlement;
  const promotions = entitlement.promotions?.length || 0;
  const history = useHistory();

  return (
    <Fragment>
      <EntitlementsCommonColumns entitlement={entitlement} refetch={refetch} />
      {!isAppEntitlement(entitlement?.offering?.type as OfferingType) ? (
        <SummarySectionV2.SummaryGridCalloutItem testId="summary-add-ons">
          <div className="billing-plan billing-cycle title-height">
            <label>Additional allocations</label>
            <div className="entitlement-details-column">{addOns?.totalCount}</div>
            {addOns?.totalCount && addOns?.totalCount > 0 ? (
              <Button
                aria-label="View additional allocations"
                appearance="link"
                className="inner-text"
                testId="view-additional-allocations-btn"
                onClick={() => history.push({ hash: '#additional-allocations' })}
              >
                View
              </Button>
            ) : null}
          </div>
        </SummarySectionV2.SummaryGridCalloutItem>
      ) : (
        // empty place if it is an additional allocation (child)
        <div></div>
      )}
      <PageUrlSection entitlement={entitlement} />
      <NextPriceEstimateSection entitlement={entitlement} />
      <SummarySectionV2.SummaryGridCalloutItem testId="summary-active-promotions">
        <PromotionsSummary entitlementNumber={entitlement.entitlementNumber} promotions={promotions} />
      </SummarySectionV2.SummaryGridCalloutItem>
      <SummarySectionV2.SummaryGridCalloutItem testId="summary-unitCounts">
        <div>
          <label>Units</label>
          <p>
            {entitlement.unitCount ? (
              <span>{entitlement.unitCount}</span>
            ) : (
              <span className="data-unavailable"> N/A </span>
            )}
          </p>
        </div>
      </SummarySectionV2.SummaryGridCalloutItem>
      <UUIDSection entitlement={entitlement} />
      <StatusSection entitlement={entitlement} />
    </Fragment>
  );
};
